import React from 'react'
import { useSelector } from 'react-redux'

import { getOrganization } from 'data/organizations/selectors'
import PopoverOnClick from 'components/Utils/Popover/PopoverOnClick'
import OrganizationDropdownButton from './Button'
import OrganizationDropdownBody from './Body'
import { measureTimingEnd } from 'data/metrics'

export default React.memo(function OrganizationDropdown() {
  const organization = useSelector(getOrganization)

  React.useEffect(
    function onMount() {
      if (organization) {
        measureTimingEnd('TIME_TO_LOAD_APP')
      }
    },
    [organization]
  )

  if (!organization) {
    return null
  }

  return (
    <PopoverOnClick
      position="bottom"
      align="end"
      containerStyle={{ zIndex: 9 }}
      content={<OrganizationDropdownBody />}
    >
      <div className="pointer">
        <OrganizationDropdownButton organization={organization} />
      </div>
    </PopoverOnClick>
  )
})
